import { render, staticRenderFns } from "./NewRoom.vue?vue&type=template&id=7a67d8e5&scoped=true&"
import script from "./NewRoom.vue?vue&type=script&lang=js&"
export * from "./NewRoom.vue?vue&type=script&lang=js&"
import style0 from "./NewRoom.vue?vue&type=style&index=0&id=7a67d8e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a67d8e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a67d8e5')) {
      api.createRecord('7a67d8e5', component.options)
    } else {
      api.reload('7a67d8e5', component.options)
    }
    module.hot.accept("./NewRoom.vue?vue&type=template&id=7a67d8e5&scoped=true&", function () {
      api.rerender('7a67d8e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/battle/components/NewRoom.vue"
export default component.exports